import { RootState } from 'src/redux/createRootReducer'
import { ErrorDetailMap } from 'src/utils/error.utils'

export const selectPuttingVirtualCardCancelFromState = (
  state: RootState,
): boolean => state.app.deactivateVirtualCardContent.puttingVirtualCardCancel

export const selectTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.deactivateVirtualCardContent.topLevelError

export const selectErrorDetailMapFromState = (
  state: RootState,
): ErrorDetailMap<string> | undefined =>
  state.app.deactivateVirtualCardContent.errorDetailMap
